function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFashionAndBeauty = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.979,9.788C11.979,7.17 14.107,5.041 16.726,5.041C19.344,5.041 21.472,7.17 21.472,9.788L21.472,13.348L11.979,13.348L11.979,9.788ZM8.419,13.348L3.672,13.348C1.706,13.348 0.112,14.943 0.112,16.908L0.112,32.336C0.112,36.267 3.301,39.456 7.232,39.456L26.219,39.456C30.15,39.456 33.339,36.267 33.339,32.336L33.339,16.908C33.339,14.943 31.745,13.348 29.779,13.348L25.033,13.348L25.033,9.788C25.033,5.197 21.317,1.481 16.726,1.481C12.135,1.481 8.419,5.197 8.419,9.788L8.419,13.348ZM10.199,20.469C9.212,20.469 8.419,19.675 8.419,18.689C8.419,17.702 9.212,16.908 10.199,16.908C11.185,16.908 11.979,17.702 11.979,18.689C11.979,19.675 11.185,20.469 10.199,20.469ZM25.033,18.689C25.033,19.675 24.239,20.469 23.252,20.469C22.266,20.469 21.472,19.675 21.472,18.689C21.472,17.702 22.266,16.908 23.252,16.908C24.239,16.908 25.033,17.702 25.033,18.689Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFashionAndBeauty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fashion-and-beauty.aba56d463e708c11df9faf75925e31e1.svg";